module.exports = __webpack_public_path__ + "img/c03_unitsacreddeer_Normal_ua.02eeb043.webp";